module.exports = "pegasus_template/assets/rectangle-facebook.png";